import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Container from '../components/container'
import Breadcrumb from '../components/breadcrumb'
import SearchBar from '../components/search-bar'
import RelatedPages from '../components/related-pages'
import BlogPostPreviewList from '../components/blog-post-preview-list'
import DynamicZoneComponent from '../components/dynamic-zone-component'
import Markdown from "react-markdown";

import { getEntityUrl} from '../lib/helpers'

import * as styles from './blog-post.module.css'

function BlogPost ({article}) {
  const image = getImage(article?.main_image?.imageFile)
  return (
    <>
        <Container>
            <Breadcrumb thisPage={article}></Breadcrumb>
            <h1 className={styles.title}>{article.title}</h1>
            { article.excerpt && 
                <span>{article.excerpt}</span>
            }
            <ul>
                {article.authors &&
                article.authors.map(entity => (
                    <li key={entity._id}>
                        <Link to={getEntityUrl(entity)}>{entity.name}</Link>
                    </li>
                ))}
            </ul>
            <ul>
                {article.authorities &&
                article.authorities.map(entity => (
                    <li key={entity._id}>
                        <Link to={getEntityUrl(entity)}>{entity.name}</Link>
                    </li>
                ))}
            </ul>
            {article.children && article.children.length > 0 && (
                <>
                <BlogPostPreviewList
                    nodes={article.children}
                    max_n="5"
                    page_type={article.page_type}
                />
                </>
            )}
        </Container>
        {
        // main image
        article.main_image && article.children && article.children.length === 0 &&
        <div className={styles.hero}>
            <GatsbyImage image={image} alt={article.main_image.alternativeText ? article.main_image.alternativeText : "a nice image" } />
            {article.main_image.caption}
        </div>
        }
        <Container>
            <Markdown children={article.body_introduction} skipHtml={true} />
            { 
                // display body components
                article.body && 
                <>
                {article.body.map(component => component && (
                    <div key={component._id}>
                        <DynamicZoneComponent component={component}></DynamicZoneComponent>
                    </div>
                ))}
                </>
            }
            <Markdown children={article.body_conclution} skipHtml={true} />

            <SearchBar></SearchBar>
            {
                // related pages
                article.related_pages && article.related_pages.length > 0 && (
                <RelatedPages nodes={article.related_pages}></RelatedPages>
            )}
        </Container>
    </>
  )
}

export default BlogPost
